<template>
    <div class="modal-mask">
        <div id="examTop"></div>
        <div class="modal-wrapper">
            <div class="modal-container d-flex flex-column">
                <header class="mdc-top-app-bar position-static">
                    <div class="mdc-top-app-bar__row">
                        <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start">
                            <a class="material-icons mdc-top-app-bar__navigation-icon" @click="closeExamResult()">close</a>
                        </section>
                        
                        <section class="mdc-top-app-bar__section title">
                            <div class="mdc-top-app-bar__title">
                                <!-- {{examTitle}} -->
                                Feedback
                            </div>                
                        </section>

                        <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end">
                            <a class="material-icons mdc-top-app-bar__action-item" aria-label="search" alt="search"></a>
                        </section>
                    </div>
                    
                    
                </header>
                <section class="flex-grow-1 scroll-y">
                    <question-navi-result
                        v-if="solves.length"
                        :solves="solves"
                        :currentQuestionId="currentQuestion.questionId"
                        @selectQuestionNavi="selectQuestionNavi"
                        ></question-navi-result>
                    <component v-if="currentQuestion" ref="questionComp"
                        :is="currentQuestion.type.value" 
                        :question="currentQuestion"
                        :groupQuestionCount="currentGroupQuestionCount"
                        :groupQuestionTitle="currentGroupQuestionTitle"
                        :paperLevel="paperLevel"
                        :feedback="feedback"
                        :key="currentQuestion.id"
                    >
                    </component>
                </section>

                <section>
                   
                    <div class="d-flex flex-row justify-content-between pdt-10 pdb-10 pdl-16 pdr-16 bottom-shadow">
                        <div>
                            <button class="mdc-button btn-white t-color-secondaryBtnText" @click="previous()" v-if="showBtnPrev()">
                                <i class="material-icons mdc-button__icon">keyboard_arrow_left</i>
                                {{$t('1245')}}
                                <!--  -->
                            </button>
                        </div>
                        <div>
                            <button class="mdc-button btn-white t-color-secondaryBtnText" @click="next()" v-if="showBtnNext()">
                                {{$t('1246')}}
                                <!-- NEXT -->
                                <i class="material-icons mdc-button__icon">keyboard_arrow_right</i>
                            </button>

                            <button class="mdc-button mdc-button--raised btn-red" @click="complete()" v-if="showBtnComplete()">
                                {{$t('COMPLETE')}}
                                <!-- COMPLETE -->
                            </button>
                        </div>

                    </div>
                </section>
                
            </div>
        </div>
        <transition name="fade">
            <router-view></router-view>
        </transition>
        
    </div>
    
</template>


<script>
/**
 * 시험 피드백 메인 컴포넌트(exam feedback main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import examApi from '@/api/examApi.js'
import QuestionNaviResult from './QuestionNaviResult'
import {examMixin} from '@/mixins/exam.js'
import {MDCRipple} from '@material/ripple'

export default {
    data() {
        return {
            examTitle: '',
            paperLevel: '',
            
            paper: [],
            solves: [],
            questionSequence: '',
            questionGroup: null,
            feedback: null,
            paperLevel: '',

            currentQuestion: null,
            currentGroupIndex: 0,
            currentQuestionIndex: 0,
            currentGroupQuestionCount: 0,
            
        }
    },
    components: {
        'question-navi-result': QuestionNaviResult,
        'SHORT_ANSWER': () => import('./question/ShortAnswerFeedback.vue'),
        'CHOICE_SINGLE': () => import('./question/ChoiceSingleFeedback.vue'),
        'TRUE_OR_FALSE': () => import('./question/ChoiceSingleFeedback.vue'),
        'CHOICE_MULTIPLE': () => import('./question/ChoiceMultipleFeedback.vue'),
        'FILL_IN_THE_RANGE': () => import('./question/FillInTheRangeFeedback.vue'),
        'FILL_IN_THE_BLANK': () => import('./question/FillInTheBlankFeedback.vue'),
        'ESSAY': () => import('./question/EssayFeedback.vue'),
    },
    mixins: [examMixin],

    mounted() {
        this.setExamPaper()
        this.setMaterialUi()
    },

    
    methods: {
        // call api & set exam feedback data
        setExamPaper() {
            let responseData = null
            let params = {
                examineeId: this.$route.params.examineeId,
                paperId: this.$route.params.paperId
            }

            // call api exam result
            examApi.result(params).then((response) => {
                responseData = response.data.data
                console.log('result responseData', responseData)

                this.examTitle = responseData.name
                this.paper = responseData.groups
                this.feedback = responseData.feedback
                this.paperLevel = responseData.level ? responseData.level.text : ''

                let number = 1
                _.each(this.paper, (group, groupIndex) => {
                    _.each(group.questions, (question, questionIndex) => {
                        question.groupIndex = groupIndex
                        question.questionIndex = questionIndex
                        question.number = number++
                        question.groupId = group.id
                    })
                })

                this.setCurrentQuestion()
                this.initAnswers()
            }).catch((err) => {
                
            })
        },

        // get question group
        getQuestionGroup() {
            this.questionGroup = this.paper[this.currentQuestionIndex]
        },

        // set current question
        setCurrentQuestion() {
            this.currentQuestion = this.paper[this.currentGroupIndex].questions[this.currentQuestionIndex]
            this.currentGroupQuestionCount = this.paper[this.currentGroupIndex].questions.length
            this.currentGroupQuestionTitle = this.paper[this.currentGroupIndex].name
        },

        isFirst() {
            return this.currentGroupIndex || this.currentQuestionIndex
        },

        isGroup() {
            return this.paper[this.currentGroupIndex].questions.length > 1 ? true : false
        },

        isLastGroupQuestion() {
            return this.paper[this.currentGroupIndex].questions.length === this.currentQuestionIndex+1 ? true : false
        },

        isGroupLast(){
            return this.paper.length === this.currentGroupIndex+1 ? true : false
        },

        isChecked() {
            return this.answers && this.currentQuestion ? this.answers[this.currentQuestion.id].checkStatus : false
        },

        
        showBtnNext() {
            return !this.isGroupLast() || !this.isLastGroupQuestion()
        },

        showBtnPrev() {
            return this.isFirst()
        },

        showBtnComplete() {
            return this.isGroupLast() && this.isLastGroupQuestion()
        },
        


        
        next() {                        
            this.currentQuestionCheckStatus = false
            
            if (this.isGroup()) {                
                // is group question
                if (this.isLastGroupQuestion()) {
                    // is group last question
                    this.currentGroupIndex++
                    this.currentQuestionIndex = 0
                }else {
                    // is not group last question
                    this.currentQuestionIndex++
                }
            }else {
                // is not group question
                this.currentGroupIndex++
                this.currentQuestionIndex = 0
            }
            this.setCurrentQuestion()
        },

        previous() {
            this.currentQuestionCheckStatus = false
            if (this.isGroup()) {  
                // is group question
                if (!this.currentQuestionIndex) { 
                    // 그룹내 마지막 문항(is group last question)
                    this.currentQuestionIndex = this.paper[this.currentGroupIndex-1].questions.length-1
                    this.currentGroupIndex--
                }else { 
                    // 그룹내 이전 문항(is not group last question)
                    this.currentQuestionIndex--
                }
            } else{
                // is not group question
                this.currentQuestionIndex = this.paper[this.currentGroupIndex-1].questions.length-1
                this.currentGroupIndex--
            }

            this.setCurrentQuestion()
        },

        // close Exam Result pop
        closeExamResult() {
            this.routerGoPrev() 
            // this.$confirm({
            //     title: '',
            //     content: this.$t('50022'),  //시험 피드백 보기를 종료하시겠습니까?
            //     accept:  this.$t('50023'),  // 확인
            //     cancel:  this.$t('50024'),  // 취소
            // }).then(() => {
            //     this.routerGoPrev()      
            // }).catch(() => {})
        },

        complete() {
            this.routerGoPrev()
        },
        
        initAnswers() {
            let questionsData = _.chain(this.paper)
                .map(function (item) {
                    return item.questions;
                })
                .flatten()
                .map(function (question, index) {
                    return question
                }).value()

            
            
            _.each(questionsData, (question) => {
                this.solves.push({
                    number: question.number,
                    questionId: question.questionId,
                    groupIndex: question.groupIndex,
                    questionIndex: question.questionIndex,
                    correct: question.correct
                })
            })
        },

        // select question navigation
        selectQuestionNavi(data) {
            this.currentGroupIndex = data.groupIndex
            this.currentQuestionIndex = data.questionIndex
            this.setCurrentQuestion()            
        },
        setMaterialUi() {
            const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
                let button = new MDCRipple.attachTo(el)
                return button
            })
        },
    }
}
</script>